import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontBody1Family, Spacing12 } from 'autogen/design-tokens/tokens';
import type { BasketAddMinimumBuySuccess } from 'autogen/swagger/all';
import { Notice } from 'autogen/translation-keys/trans-website-shared';
import Image from 'components/generic/Image';
import PriceModule from 'components/generic/PriceModule';
import ProductName from 'components/generic/productName/ProductName';
import { Typography } from 'components/generic/typography';
import FlexColumn from 'components/Layout/components/Flex/components/FlexColumn';
import format from 'helpers/translations';
import { breakpoint, sizes } from 'variables';

const ProductImage = styled(Image)`
    max-width: 160px;

    ${breakpoint.down(sizes.sm)} {
        max-width: 180px;
    }
`;

const ProductItemLines = styled.h3`
    font-family: ${FontBody1Family};
`;

export const BasketAddMinimumQuantityBuy = ({ model }: { model: BasketAddMinimumBuySuccess }) => {
    const { t } = useTranslation();

    const specialPrice =
        model.specialPriceAfter?.length && model.specialPriceBefore?.length && model.specialPriceFirstTime?.length;

    return (
        <FlexColumn gap={Spacing12}>
            <Typography.Headline size="M">{t(Notice)}</Typography.Headline>
            <Typography.Body>{format(model.noticeDescription)}</Typography.Body>
            <div>
                <ProductImage src={model.primaryImage.url} alt={model.productName} />
            </div>
            <ProductItemLines>
                <ProductName productName={model.productListName} size="lg" />
            </ProductItemLines>
            {specialPrice && model.specialPriceFirstTime ? (
                <div>
                    <PriceModule
                        price={model.specialPriceFirstTime}
                        priceBefore={model.specialPriceBefore}
                        isOnDiscount
                        minimumSalesQuantity={model.minimumSalesQuantity}
                        size="lg"
                    />
                </div>
            ) : (
                <div>
                    <div>
                        <PriceModule
                            price={model.basePriceText}
                            priceBefore={model.basePriceBeforeText}
                            isOnDiscount
                            minimumSalesQuantity={model.minimumSalesQuantity}
                            size="sm"
                        />
                    </div>
                    <div>
                        <PriceModule
                            price={model.minimumBuyPriceText}
                            priceBefore={model.minimumBuyPriceBeforeText}
                            size="lg"
                            isOnDiscount
                            minimumSalesQuantity={model.minimumSalesQuantity}
                        />
                    </div>
                </div>
            )}
        </FlexColumn>
    );
};
